import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from '../../../../../common/names';
import {IProxyServer} from '../../../../../types/ProxyServer';
import ProxyForm from 'features/layout/DialogRoutes/dialogs/proxies/ProxyForm';
import Button from 'components/Button';
import {useTranslation} from 'react-i18next';
import {Box} from '@mui/material';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

type Props = {
   onClose: () => void;
   proxy: IProxyServer;
};

const ViewProxyDialog: ReactFChildrenProps<Props> = memo(({onClose, proxy}) => {
   const {t} = useTranslation();

   return (
      <DialogComponent maxWidth="md" header={DialogTypes.ViewProxy.dialogName} close={onClose}>
         <ProxyForm initialValues={proxy} readonly onClose={onClose} />
         <Box textAlign={'center'} paddingTop={2}>
            <Button onClick={onClose}>{t('Done')}</Button>
         </Box>
      </DialogComponent>
   );
});

export default ViewProxyDialog;
